import { Response } from '@marketplace-web/core-api/api-client-util'

import { transformProfileUserInfoDto } from './profile-user-info'
import { ProfileUserInfoDto } from '../types/dtos/profile-user-info'

export const transformProfileUserInfoResponse = (response: Response<ProfileUserInfoDto>) =>
  transformProfileUserInfoDto(response)
